import { authHeaders } from "@/services/assets/assetHelpers";
import type { PendingPolicyCampaign, PublishedPrivacyPolicy } from "@/types/platformAudit";

const API_BASE_URL = import.meta.env?.VITE_API_URL ?? "https://tellerwand.com";
const GDPR_BASE = `${API_BASE_URL}/api/v1/gdpr`;

export async function fetchPublishedPrivacyPolicy(): Promise<PublishedPrivacyPolicy | null> {
  const response = await fetch(`${GDPR_BASE}/published-policy`);
  if (!response.ok) {
    return null;
  }
  const body = await response.json();
  return body.data ?? null;
}

export async function fetchPendingPolicyAck(): Promise<PendingPolicyCampaign | null> {
  const response = await fetch(`${GDPR_BASE}/policy-ack/status`, {
    headers: await authHeaders(),
  });
  if (!response.ok) {
    return null;
  }
  const body = await response.json();
  return body.data ?? null;
}

/**
 * Validate Policy Ack Token.
 */
export async function validatePolicyAckToken(token: string) {
  const response = await fetch(`${GDPR_BASE}/policy-ack/validate`, {
    method: "POST",
    headers: {
      ...(await authHeaders()),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token }),
  });
  const body = await response.json();
  if (!response.ok) {
    throw new Error(body.error || "Token validation failed");
  }
  return body.data;
}

/**
 * Acknowledge Policy Token.
 */
export async function acknowledgePolicyToken(token: string, mfaCode: string) {
  const response = await fetch(`${GDPR_BASE}/policy-ack/acknowledge`, {
    method: "POST",
    headers: {
      ...(await authHeaders()),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token, mfaCode }),
  });
  const body = await response.json();
  if (!response.ok) {
    throw new Error(body.error || body.data?.reason || "Acknowledgement failed");
  }
  return body.data;
}
